import { Parametric } from '../cliente/parametric.model';
import { BackendModel, BackendService } from '../core/backend.service';
import { NotificacionWho } from './notificacionWho.model';

export class Notificacion extends BackendModel {

  static path = '/notificaciones/';

  id: number;
  texto: string;
  asunto: string;
  telefono_id: number;
  email_id: number;
  username: string;
  fechaEnvio: Date;
  enviado: Boolean;
  importante: Boolean = false;
  generica: Boolean = true;
  fechaDesde: Date | 'dd/MM/yyyy';
  fechaHasta: Date | 'dd/MM/yyyy';
  clientesChip?: string[];
  notificacionesWho: NotificacionWho[];

  constructor(protected backendService: BackendService, model?: Notificacion) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion.model.ts